import React, { Suspense, useMemo } from 'react';

import { IconTypes } from '@eika/icon';
import { LinkCard } from '@eika/link-panel';

import { useConfig } from '../../defaultConfig';
import { useSuspendedAvtaleGiroProposals } from '../../fetchHooks/useAvtalegiro';
import useTranslation from '../../hooks/useTranslation';
import AvtaleGiroProposalLinkCardSkeleton from './AvtaleGiroProposalLinkCardSkeleton';

const AvtaleGiroProposalLinkCard: React.FC = () => {
    const translated = useTranslation();
    const { data: avtaleGiroProposals, status } = useSuspendedAvtaleGiroProposals();
    const { avtalegiroLink } = useConfig();
    const numberOfProposals = useMemo(() => avtaleGiroProposals.length, [avtaleGiroProposals]);

    if ((numberOfProposals === 0 && status === 'success') || status === 'error' || !avtalegiroLink) return null;
    return (
        <div className="sgw-content">
            <LinkCard
                title={translated.avtaleGiroProposals.proposalToAvtalegiro}
                notification={numberOfProposals}
                textOne={translated.avtaleGiroProposals.onRepeatingEFaktura}
                icon={IconTypes.INBOX_24}
                url={avtalegiroLink.url}
            />
        </div>
    );
};

export default () => (
    <Suspense fallback={<AvtaleGiroProposalLinkCardSkeleton />}>
        <AvtaleGiroProposalLinkCard />
    </Suspense>
);
